export const getMaxDivider = (ticksCount: number): number => {
  if (ticksCount < 11) {
    return ticksCount
  }

  for (let i = 10; i >= 2; i--) {
    if (ticksCount % i === 0) {
      return i
    }
  }

  return ticksCount / 2
}
